import {applyMiddleware, compose, createStore} from 'redux';
import httpResponseErrorHandler from './store/httpResponseErrorHandler';
import reducers from 'store/reducers';
import thunk from 'redux-thunk';

// 參考資料 : https://ithelp.ithome.com.tw/articles/10187344
/*
const logger = store => dispatch => action => {
    console.log('dispatching', action);
    let result = dispatch(action);
    console.log('next state', store.getState());
    return result;
};
*/

const composeEnhancers =
    typeof window === 'object' &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({}) : compose;

const enhancer = composeEnhancers(
    applyMiddleware(thunk, httpResponseErrorHandler)
);

const store = createStore(reducers, enhancer);

export default store;



// WEBPACK FOOTER //
// ./src/store.js